module.exports = __webpack_public_path__ + "img/Préparation installation verrière inox..e25aa0e1.jpg";